'use client'

import { useAtomValue } from 'jotai'
import { ComponentType, useEffect, useState } from 'react'

import { isDeleteAccountSuccessDialogOpenAtom } from '@/global-state'

import { TDeleteAccountSuccessDialogProps } from './DeleteAccountSuccessDialog'

export const LazyDeleteAccountSuccessDialog = ({
	translations,
}: {
	translations: TDeleteAccountSuccessDialogProps['translations']
}) => {
	const isOpen = useAtomValue(isDeleteAccountSuccessDialogOpenAtom)
	const [Dialog, setDialog] =
		useState<ComponentType<TDeleteAccountSuccessDialogProps> | null>(null)

	useEffect(() => {
		const loadDialog = async () => {
			const mod = await import('./DeleteAccountSuccessDialog')
			setDialog(() => mod.DeleteAccountSuccessDialog)
		}
		if (isOpen && !Dialog) {
			void loadDialog()
		}
	}, [Dialog, isOpen])

	return Dialog ? <Dialog translations={translations} /> : null
}
